import { useState, useEffect, useCallback } from 'react';
import { getTrustHorizonInfo } from 'services/case/caseServices';

const useTrustHorizon = (case_id, trustBalance, shouldLoad) => {
  const [trustHorizonData, setTrustHorizonData] = useState();
  const [trustHorizonLoading, setTrustHorizonLoading] = useState(false);
  const [trustHorizonError, setTrustHorizonError] = useState(null);
  const [previousTrustBalance, setPreviousTrustBalance] = useState(null);

  const loadTrustHorizonData = useCallback(async () => {
    if (!case_id || !shouldLoad) {
      return;
    }

    setTrustHorizonLoading(true);
    setTrustHorizonError(null);

    try {
      const response = await getTrustHorizonInfo(case_id);

      if (response?.data) {
        setTrustHorizonData(response.data);
      }
    } catch (error) {
      console.log('Trust Horizon: Error:', error);
      if (error?.response?.status === 404) {
        setTrustHorizonError(error?.response?.data?.error ? error?.response?.data?.error : 'No data available');
      } else {
        setTrustHorizonError('No data available');
      }
    } finally {
      setTrustHorizonLoading(false);
    }
  }, [case_id, shouldLoad]);

  useEffect(() => {
    loadTrustHorizonData();
  }, [loadTrustHorizonData]);

  useEffect(() => {
    if (!shouldLoad) {
      setTrustHorizonData(undefined);
      setTrustHorizonError(null);
    }
  }, [shouldLoad]);

  useEffect(() => {
    if (shouldLoad && trustBalance !== previousTrustBalance) {
      setPreviousTrustBalance(trustBalance);
      loadTrustHorizonData();
    }
  }, [shouldLoad, trustBalance, previousTrustBalance, loadTrustHorizonData]);

  const refreshTrustHorizon = useCallback(() => {
    loadTrustHorizonData();
  }, [loadTrustHorizonData]);

  return {
    trustHorizonData,
    trustHorizonLoading,
    trustHorizonError,
    refreshTrustHorizon,
  };
};

export default useTrustHorizon;
